<!-- components/dashboard/cards/OrdemPlanejamentoCard.vue -->
<template>
  <div class="ordem-planejamento-card" :class="{ 'urgente': ordem.urgente, 'atrasada': ordem.atrasada }">
    <div class="card-header">
      <div class="ordem-info">
        <strong>#{{ ordem.id_ordem || ordem.id }}</strong>
        <span class="cliente">{{ ordem.cliente }}</span>
      </div>
      <button @click="$emit('remover', ordem, dia)" class="btn-remover" title="Remover do planejamento">
        ✕
      </button>
    </div>
    
    <div class="card-body">
      <div class="produto">{{ ordem.produto }}</div>
      
      <div class="detalhes">
        <span class="quantidade">{{ ordem.quantidadeTotal }} un</span>
        <span class="tempo">{{ ordem.tempoEstimadoFormatado || ordem.tempoEstimado?.formatado }}</span>
      </div>
      
      <div v-if="ordem.setorNome" class="setor-info">
        <span class="setor">{{ ordem.setorNome }}</span>
        <span v-if="ordem.posicaoNoDia" class="posicao">{{ ordem.posicaoNoDia }}º</span>
      </div>
    </div>
    
    <div class="card-footer">
      <div class="badges">
        <span v-if="ordem.urgente" class="badge urgente">⚡ URGENTE</span>
        <span v-if="ordem.atrasada" class="badge atrasada">🚨 ATRASADA</span>
      </div>
      
      <button @click="$emit('selecionar', ordem)" class="btn-detalhes" title="Ver detalhes">
        👁️
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrdemPlanejamentoCard',
  props: {
    ordem: {
      type: Object,
      required: true
    },
    dia: {
      type: Object,
      required: true
    }
  },
  emits: ['remover', 'selecionar']
}
</script>

<style scoped>
.ordem-planejamento-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.ordem-planejamento-card:hover {
  border-color: #3498db;
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.ordem-planejamento-card.urgente {
  border-left: 4px solid #e74c3c;
  background: linear-gradient(90deg, #fff5f5 0%, white 20%);
}

.ordem-planejamento-card.atrasada {
  border-left: 4px solid #f39c12;
  background: linear-gradient(90deg, #fef9e7 0%, white 20%);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.ordem-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ordem-info strong {
  color: #2c3e50;
  font-size: 13px;
}

.cliente {
  color: #7f8c8d;
  font-size: 11px;
}

.btn-remover {
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.btn-remover:hover {
  background: #c0392b;
  transform: scale(1.1);
}

.card-body {
  margin-bottom: 8px;
}

.produto {
  color: #34495e;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 4px;
}

.detalhes {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #7f8c8d;
  margin-bottom: 4px;
}

.setor-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 10px;
}

.setor {
  color: #3498db;
  font-weight: 500;
}

.posicao {
  background: #3498db;
  color: white;
  padding: 1px 4px;
  border-radius: 8px;
  font-weight: bold;
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.badges {
  display: flex;
  gap: 4px;
}

.badge {
  font-size: 8px;
  padding: 2px 4px;
  border-radius: 6px;
  color: white;
  font-weight: bold;
}

.badge.urgente {
  background: #e74c3c;
}

.badge.atrasada {
  background: #f39c12;
}

.btn-detalhes {
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  width: 24px;
  height: 20px;
  font-size: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-detalhes:hover {
  background: #2980b9;
  transform: scale(1.1);
}
</style>